mutation StopYouTubeSessionAsStaff($accountId: ID!, $channelId: String!, $sessionId: ID!) {
  result: StreamToolsStopYouTubeSessionAsStaff(accountId: $accountId, channelId: $channelId, sessionId: $sessionId) {
    stopped
    session {
      sessionId
      eventId
      scope
      status
      startedAt
      stoppedAt
      stopReason
      channelId
      channelTitle
      videoId
      channelProfileImageUrl
      foreignEvent
    }
  }
}
